module.exports = __webpack_public_path__ + "static/media/data-hora-icon.341c1ec9.svg";